import { FirebaseError } from "firebase/app";

interface RetErr {
  msg: string;
};

function authGeneralErrorHandle(e: FirebaseError) {
  const retVal: RetErr = {msg: ""};
  switch (e.code) {
    case "auth/email-already-exists":
      retVal.msg = "Email already exists, please try again";
      break;
    case "auth/invalid-display-name":
      retVal.msg = "Username is invalid, it cannot be empty";
      break;
    case "auth/invalid-email":
      retVal.msg = "Email is invalid, please try again";
      break;
    case "auth/invalid-password":
      retVal.msg = "Password is invalid, it must be greater than 6 characters";
      break;
    case "auth/weak-password":
      retVal.msg = "Password is too weak, it must contain at least 6 characters";
      break;
    case "auth/email-already-in-use":
      retVal.msg = "Email already in use, please try again";
      break;
    case "auth/wrong-password":
      retVal.msg = "Invalid email or password. Please try again";
      break;
    case "auth/user-not-found":
      retVal.msg = "Invalid email or password. Please try again";
      break;
    case "auth/missing-email":
      retVal.msg = "Email cannot be empty";
      break;
    case "auth/invalid-action-code":
      retVal.msg = "Code is invalid";
      break;
    default:
      retVal.msg = "There was an error. Please try again";
      break;
  }
  return retVal;
}

export { authGeneralErrorHandle }